import { useEffect } from "react";

export default function ArticleSchemaMarkup({
  canonical,
  headline,
  description,
  image,
  datePublished,
  dateModified,
  articleSection = "Audio Education",
  keywords = [],
  inLanguage = "en-US",
  breadcrumbs = [],
}) {
  useEffect(() => {
    if (!canonical || !headline || !description) return;

    const normalizedImage = Array.isArray(image)
      ? image
      : image
      ? [image]
      : undefined;

    const articleId = `${canonical}#article`;
    const webpageId = `${canonical}#webpage`;
    const breadcrumbId = `${canonical}#breadcrumb`;

    const articleSchema = {
      "@context": "https://schema.org",
      "@type": "Article",
      "@id": articleId,
      url: canonical,
      headline,
      description,
      image: normalizedImage,
      inLanguage,
      articleSection,
      keywords: keywords.length > 0 ? keywords : undefined,
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": webpageId,
      },
      isPartOf: {
        "@id": "https://parishaudio.com/#website",
      },
      author: {
        "@id": "https://parishaudio.com/#organization",
      },
      publisher: {
        "@id": "https://parishaudio.com/#organization",
      },
      ...(datePublished ? { datePublished } : {}),
      ...(dateModified ? { dateModified } : {}),
    };

    const webPageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": webpageId,
      url: canonical,
      name: headline,
      description,
      isPartOf: {
        "@id": "https://parishaudio.com/#website",
      },
      about: {
        "@id": articleId,
      },
      inLanguage,
    };

    const breadcrumbSchema =
      breadcrumbs.length > 0
        ? {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id": breadcrumbId,
            itemListElement: breadcrumbs.map((crumb, index) => ({
              "@type": "ListItem",
              position: index + 1,
              name: crumb.name,
              item: crumb.item,
            })),
          }
        : null;

    const graph = [articleSchema, webPageSchema, breadcrumbSchema].filter(Boolean);
    const cleanedGraph = JSON.parse(JSON.stringify(graph));

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(cleanedGraph);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [
    canonical,
    headline,
    description,
    image,
    datePublished,
    dateModified,
    articleSection,
    keywords,
    inLanguage,
    breadcrumbs,
  ]);

  return null;
}